// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ycxp","field":"styles_field__3gqV8","fieldCol":"styles_fieldCol__3-TcX","diffCol":"styles_diffCol__2Sfm_","diff":"styles_diff__35mYi"};